import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Router } from '@angular/router';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { GridPageSettings, LocalStorageKeys, MenuFuncionCodes, SearchGastoItem, TenantFeatureFlags } from '../../../../../src/app/shared/model';
import { GastoService, MenuFuncionService, TenantService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-misGastos',
  templateUrl: './misGastos.component.html',
  styleUrls: ['./misGastos.component.scss']
})

export class MisGastosComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  isValidating: boolean = false;
  isSearching: boolean = false;
  canView: boolean = false;
  canViewDetalle: boolean = false;

  formGroup: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  public data: DataManager;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private service: GastoService,
    private tenantService: TenantService,
    private menuService: MenuFuncionService,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_MIS_GASTOS_UF).subscribe(data => {
      if (data != null && data.Success && data?.Result) {

        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.canView = true;
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;
          }

          this.menuService.checkMenu(MenuFuncionCodes.MI_GASTO_LIST).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
              this.canViewDetalle = true;
            }

            this.loadView();
          },
          (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
          });
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err);
        })
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getDashboardMisGastosUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    setTimeout(() => {
      if (this.grid?.getRows()?.length > 0)
        this.grid?.autoFitColumns()
    }, 1000);
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
    console.error(event);
  }

  loadDashboard() {
    this.setQueryParams();
    this.grid.refresh();

    setTimeout(() => {
      if (this.grid?.getRows()?.length > 0)
        this.grid?.autoFitColumns()
    }, 1000);
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "VerSoloPendientesLiquidacion");
    if (index >= 0)
      this.query.params[index].value = "true";
    else
      this.query.addParams("VerSoloPendientesLiquidacion", "true");

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = "true";
    else
      this.query.addParams("VerSoloActivos", "true");
  }

  view(item: SearchGastoItem) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['gasto-edit', item.Id]);
  }

  viewAll() {
    if (!this.canViewDetalle) {
      this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
      return false;
    }

    this.router.navigate(['mi-gasto-list']);
  }
}
